export default {
  root: {
    minWidth: 100,
  }
};
